/**
 * Animaciones del mapa que respetan "reducir movimiento" del sistema.
 * Leaflet anima el desplazamiento en JS, así que la regla CSS de
 * prefers-reduced-motion no lo alcanza: hay que leer la media query aquí.
 * Con movimiento reducido el mapa SALTA al destino en vez de recorrerlo.
 *
 * Ojo con Leaflet: `flyTo(..., { duration: 0 })` NO desactiva la animación
 * — con 0 calcula la duración por defecto según la distancia (`duration ?
 * 1000 * duration : 1000 * S * 0.8`), que suele ser MÁS larga. Lo que la
 * apaga es `animate: false` (Leaflet cae a `setView`).
 */
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function flyOptions(duration: number): { duration: number } | { animate: false } {
  return prefersReducedMotion() ? { animate: false } : { duration };
}
